import numeralFormatter, { NumeralFormats } from './numeralFormatter';

const percentageCellFormatter = ({ value, format = NumeralFormats.PERCENTAGE_6 }) =>
  numeralFormatter({ value: parseFloat(value / 100), format }); // divide by 100 because numeral expects value 0...1 to format as percentage and DB returns 0...100

export default percentageCellFormatter;
